import simplestring from "./SimpleString"; // type-able - done
import yesno from "./YesNo";
import singleselect from "./SingleSelect";
import percentage from "./Percentage";
import multiselect from "./MultiSelect";
import date from "./Date";
import email from "./Email"; // type-able - done
import number from "./Number"; // type-able -
import currency from "./Currency"; // type-able
import contact from "./ContactNumber"; // type-able
import singleselectplatinum from "./SingleSelectPlatinum";
import bundleset from "./BundleSet";
import multiselectplatinum from "./MultiSelectPlatinum";
import year from "./Year"; // type-able
import address from "./Address"; // type-able
import largestring from "./Largestring"; // type-able
import message from "./Message";
import multistring from "./MultiString";
import multitext from "./MultiText";
import documentupload from "./DocumentUpload"; // type-able
import schedule from "./Schedule"; // type-able
import operationtable from "./OperationTable"

// NOT IMPLEMENTED YET
import daterange from "./DateRange";

const questions = {
  simplestring,
  yesno,
  singleselect,
  percentage,
  multiselect,
  multitext,
  date,
  daterange,
  email,
  number,
  currency,
  contact,
  singleselectplatinum,
  multiselectplatinum,
  year,
  address,
  largestring,
  message,
  multistring,
  schedule,
  documentupload,
  operationtable,
  bundleset
};

const Question = ({ type }) => {
  if (questions[type]) {
    return questions[type];
  }

  return UnknownQuestion;
};

const UnknownQuestion = ({ node }) => {
  return <div>{node.type} is an unkown question type</div>;
};

export default Question;
